// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PaymentCardLogo_paymentCard_graphql = require("../../../__generated__/PaymentCardLogo_paymentCard_graphql.bs.js");

let convertFragment = PaymentCardLogo_paymentCard_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PaymentCardLogo_paymentCard_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PaymentCardLogo_paymentCard_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PaymentCardLogo_paymentCard_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PaymentCardLogo_paymentCard_graphql.node, convertFragment, fRef);
}

let CardFragment_cardBrandV5_decode = PaymentCardLogo_paymentCard_graphql.Utils.cardBrandV5_decode;

let CardFragment_cardBrandV5_fromString = PaymentCardLogo_paymentCard_graphql.Utils.cardBrandV5_fromString;

let CardFragment = {
  cardBrandV5_decode: CardFragment_cardBrandV5_decode,
  cardBrandV5_fromString: CardFragment_cardBrandV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let amex = (require('../../../../assets/images/amex.svg'));

let discover = (require('../../../../assets/images/discover.svg'));

let mastercard = (require('../../../../assets/images/mastercard.svg'));

let visa = (require('../../../../assets/images/visa.svg'));

let Logos = {
  amex: amex,
  discover: discover,
  mastercard: mastercard,
  visa: visa
};

function PaymentCardLogo(props) {
  let match = RescriptRelay_Fragment.useFragment(PaymentCardLogo_paymentCard_graphql.node, convertFragment, props.card);
  let brand = match.brand;
  let logo;
  if (brand === "AMERICAN_EXPRESS" || brand === "VISA" || brand === "DISCOVER" || brand === "MASTERCARD") {
    switch (brand) {
      case "AMERICAN_EXPRESS" :
        logo = amex;
        break;
      case "DISCOVER" :
        logo = discover;
        break;
      case "MASTERCARD" :
        logo = mastercard;
        break;
      case "VISA" :
        logo = visa;
        break;
    }
  } else {
    logo = visa;
  }
  let brandStr;
  if (brand === "AMERICAN_EXPRESS" || brand === "VISA" || brand === "DISCOVER" || brand === "MASTERCARD") {
    switch (brand) {
      case "AMERICAN_EXPRESS" :
        brandStr = "American Express";
        break;
      case "DISCOVER" :
        brandStr = "Discover";
        break;
      case "MASTERCARD" :
        brandStr = "Mastercard";
        break;
      case "VISA" :
        brandStr = "Visa";
        break;
    }
  } else {
    brandStr = "Unknown";
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("img", {
      className: "block",
      title: brandStr,
      alt: brandStr + ` logo`,
      src: logo
    }),
    className: TailwindMerge.twMerge([
      "border border-gray-200 rounded-md bg-gradient-to-b from-white to-gray-100",
      Stdlib_Option.getOr(props.className, "")
    ])
  });
}

let make = PaymentCardLogo;

exports.CardFragment = CardFragment;
exports.Logos = Logos;
exports.make = make;
/* amex Not a pure module */
